import manager from "./manager";
import menu from "./menu";
import list from "./list";

export default {
    manager,
    menu,
    list
}